/* src/app/modules/taxes/model-182/model-182-declarados/model-182-declarados.component.css */
:host {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.r182-declarante {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 32px;
  padding: 10px 16px;
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  background: var(--cf-surface);
  font-size: 13px;
  color: var(--cf-text);
}
.r182-resumen {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}
.r182-resumen__item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 16px;
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  background: var(--cf-surface);
  font-size: 15px;
  color: var(--cf-text);
}
.r182-resumen__item--error strong {
  color: var(--cf-error);
}
.r182-resumen__label {
  font-size: 12px;
  color: var(--cf-text-muted);
}
.r182-estado {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: var(--cf-success);
}
.r182-estado--error {
  color: var(--cf-error);
}
.r182-estado mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.r182-filtros {
  display: flex;
  align-items: center;
  gap: 8px;
}
.r182-filtros ::ng-deep .mb-3 {
  margin-bottom: 0 !important;
}
.r182-filtros ::ng-deep app-select {
  width: 190px;
}
@media (max-width: 992px) {
  .r182-resumen {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.r182-filtros ::ng-deep .qf-search {
  height: 36px;
  width: 220px;
  padding: 0 10px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  background: #fff;
  font-size: 13px;
  box-sizing: border-box;
  outline: none;
}
.r182-filtros ::ng-deep .qf-search:focus {
  border-color: var(--cf-brand-dark);
}
.r182-origen {
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid var(--cf-border);
  background: var(--cf-surface);
  font-size: 12px;
  font-weight: 600;
  color: var(--cf-text-muted);
}
.r182-origen--calculado {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
}
.r182-origen--importado {
  border-color: #fde68a;
  background: #fffbeb;
  color: #b45309;
}
.r182-importe {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.r182-help {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 1px solid var(--cf-border);
  border-radius: 50%;
  background: var(--cf-surface);
  color: var(--cf-text-muted);
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}
.r182-help:hover {
  border-color: var(--cf-brand);
  color: var(--cf-text);
}
/*# sourceMappingURL=model-182-declarados.component.css.map */
